import { createSlice, PayloadAction } from '@reduxjs/toolkit'

const initialState: {
  cacheKeys: Record<string, number>
} = {
  cacheKeys: {},
}

const commandsSlice = createSlice({
  name: 'commands',
  initialState,
  reducers: {
    addCacheKey(state, action: PayloadAction<string>) {
      state.cacheKeys[action.payload] = Date.now()
    },
    deleteCacheKey(state, action: PayloadAction<string>) {
      delete state.cacheKeys[action.payload]
    },
    resetCacheKeys(state) {
      state.cacheKeys = {}
    },
  },
})

export default commandsSlice.reducer
export const { addCacheKey } = commandsSlice.actions
